/**
 * Shared HTMX lifecycle helpers (bind-once + per-element init guards).
 * Consumed by storefront modules after DOMContentLoaded / htmx swaps.
 */
kombi.lifecycle = (function () {
  const onceKeys = Object.create(null);
  const DATASET_PREFIX = "kombiInit";
  const VALID_KEY = /^[a-zA-Z0-9_-]+$/;

  function isNonEmptyString(value) {
    return typeof value === "string" && value.length > 0;
  }

  function hasDataset(el) {
    return !!(el && el.dataset);
  }

  /**
   * "room-toggle" → "kombiInitRoomToggle" (dataset / data-kombi-init-room-toggle).
   */
  function toDatasetKey(key) {
    if (!isNonEmptyString(key) || !VALID_KEY.test(key)) {
      return null;
    }

    const parts = key.split(/[-_]/).filter(Boolean);
    if (!parts.length) {
      return null;
    }

    const pascal = parts
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join("");

    return DATASET_PREFIX + pascal;
  }

  function bindOnce(key, fn) {
    if (!isNonEmptyString(key) || typeof fn !== "function") {
      return;
    }
    if (onceKeys[key]) {
      return;
    }
    onceKeys[key] = true;
    fn();
  }

  function isInitialized(el, key) {
    if (!hasDataset(el)) {
      return false;
    }
    const datasetKey = toDatasetKey(key);
    if (!datasetKey) {
      return false;
    }
    return !!el.dataset[datasetKey];
  }

  function markInitialized(el, key) {
    if (!hasDataset(el)) {
      return;
    }
    const datasetKey = toDatasetKey(key);
    if (!datasetKey) {
      return;
    }
    el.dataset[datasetKey] = "true";
  }

  function initScope(root, fns) {
    const scope = root || document;
    if (!Array.isArray(fns)) {
      return;
    }
    fns.forEach(function (fn) {
      if (typeof fn === "function") {
        fn(scope);
      }
    });
  }

  /**
   * Register a single body listener via bindOnce.
   * options: { targetId?, onceKey? }
   * When targetId is set, handler runs only if event.detail.target.id matches.
   */
  function onBody(eventName, handler, options) {
    if (!isNonEmptyString(eventName) || typeof handler !== "function") {
      return;
    }

    const opts = options || {};
    const targetId = opts.targetId;
    const onceKey =
      opts.onceKey || eventName + ":" + (targetId || "*");

    bindOnce(onceKey, function () {
      document.body.addEventListener(eventName, function (event) {
        if (targetId) {
          const eventTarget = event.detail && event.detail.target;
          if (!eventTarget || eventTarget.id !== targetId) {
            return;
          }
        }
        handler(event);
      });
    });
  }

  return {
    bindOnce: bindOnce,
    isInitialized: isInitialized,
    markInitialized: markInitialized,
    initScope: initScope,
    onBody: onBody,
  };
})();
